import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { get, post, patch, del } from '../../api/api';

export const listarVariaveis = async () => {
  return await get<IRespostaFuncao<any[]>>('/variaveis');
};

export const criarVariavel = async (payload: { nome: string; placeholder: string }) => {
  return await post<IRespostaFuncao<any>>('/variaveis/cria-variavel', payload);
};

export const atualizarVariavel = async (id: string, payload: { nome: string; placeholder: string }) => {
  return await patch<IRespostaFuncao<any>>(`/variaveis/${id}/atualiza-variavel`, payload);
};

export const removerVariavel = async (id: string) => {
  return await del<IRespostaFuncao<any>>(`/variaveis/${id}/remove-variavel`);
};
